/** UI surface flags — Alive Album (galleries, no commerce). */
export const PRODUCT_FEATURES = {
  registeredClients: false,
  telegramIntegration: false,
  stockManagement: false,
};

export const PRODUCT_AVAILABILITY_STATUSES = ['in_stock'];

export const EXTENSION_GATED_MODULE_KEYS = new Set([
  'publisher',
  'export',
  'albums',
]);

const COMMERCE_MODULE_KEYS = [
  'orders',
  'prices',
  'promotions',
  'stock',
  'stock_alerts',
  'crm',
];

export const HIDDEN_TENANT_MODULE_KEYS = new Set([
  ...COMMERCE_MODULE_KEYS,
  ...EXTENSION_GATED_MODULE_KEYS,
]);

/**
 * Shop settings stay in the shared page for other brands.
 * Alive Album keeps the site constructor and hides the product catalog.
 */
const HIDDEN_SETTINGS_TABS = new Set([
  'clients',
  'telegram',
  'stock',
  'orders',
  'catalogSite',
  'productCard',
  'siteDictionaries',
  'design',
  'livingAlbum',
  'tenantCustom',
  // Lightroom stays out until album upload and picked-frame import are wired.
  'lightroom',
]);

export function isSettingsTabDisabled(tab) {
  return HIDDEN_SETTINGS_TABS.has(tab);
}

export const HIDDEN_IMPORT_MODES = new Set([
  'stock',
  'clients',
  'prices',
  'promotions',
]);

export function isImportModeVisible(mode) {
  return !HIDDEN_IMPORT_MODES.has(mode);
}
